module.exports = ".password-info {\r\n    padding: 20px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.password-info ul {\r\n    padding-left: 15px;\r\n    margin-bottom: 0;\r\n}\r\n\r\nul.messages {\r\n    padding-left: 15px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/change-password/change-password.component.css
// module id = ./src/app/components/change-password/change-password.component.css
// module chunks = main